<script setup>
import { ref, watch, onBeforeMount } from 'vue';

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    isIntersecting: Boolean,
})

const videoID = ref('');

onBeforeMount(() => {

    watch(
        () => props.isIntersecting,
        () => { if (props.isIntersecting === false) {
            //todo: pause video
        }}
    );

    videoID.value = props.row.content.video_url.split('v=')[1];
});
</script>
<template>
    <div class="w-full relative min-h-8" :class="row.content.height">
        <iframe 
            class="mx-auto h-full w-full"
            :src="'https://www.youtube-nocookie.com/embed/' + videoID"
            title="YouTube video player" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            referrerpolicy="strict-origin-when-cross-origin" 
            allowfullscreen
            @click="openEditorPanel"
        />
    </div>
</template>